(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode || 'daily';
      this.timezone = this.dataset.timezone || 'America/New_York';
      this.endDate = this.dataset.endDate;
      this.durationHours = parseFloat(this.dataset.durationHours) || 24;

      this.days = this.querySelector('[data-countdown-days]');
      this.hours = this.querySelector('[data-countdown-hours]');
      this.minutes = this.querySelector('[data-countdown-minutes]');
      this.seconds = this.querySelector('[data-countdown-seconds]');

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    localNow() {
      try {
        return new Date(new Date().toLocaleString('en-US', { timeZone: this.timezone }));
      } catch (error) {
        return new Date();
      }
    }

    targetDate(now) {
      if (this.mode === 'date' && this.endDate) {
        const parsed = new Date(this.endDate);
        if (!Number.isNaN(parsed.getTime())) return parsed;
      }

      if (this.mode === 'evergreen') {
        const key = 'chroma-countdown-' + this.durationHours;
        let stored = localStorage.getItem(key);
        if (!stored || Number(stored) < Date.now()) {
          stored = String(Date.now() + this.durationHours * 3600000);
          localStorage.setItem(key, stored);
        }
        return new Date(Number(stored));
      }

      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      return midnight;
    }

    tick() {
      const now = this.mode === 'daily' ? this.localNow() : new Date();
      const target = this.targetDate(now);
      let diff = target - now;

      if (diff < 0) diff = 0;

      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      const pad = (value) => String(value).padStart(2, '0');

      if (this.days) this.days.textContent = pad(d);
      if (this.hours) this.hours.textContent = pad(this.days ? h : h + d * 24);
      if (this.minutes) this.minutes.textContent = pad(m);
      if (this.seconds) this.seconds.textContent = pad(s);
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.product-gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('.product-gallery__thumb'));
      this.dots = Array.from(this.querySelectorAll('.product-gallery__dot'));
      this.index = 0;

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.thumbIndex)));
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dotIndex)));
      });

      this.querySelectorAll('[data-nav-direction]').forEach((button) => {
        button.addEventListener('click', () => {
          this.goTo(this.index + (button.dataset.navDirection === 'next' ? 1 : -1));
        });
      });

      this.addSwipe();

      document.addEventListener('chroma:variant-change', (event) => {
        const mediaId = event.detail && event.detail.featuredMediaId;
        if (!mediaId) return;
        const target = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
        if (target > -1) this.goTo(target);
      });
    }

    addSwipe() {
      const viewport = this.querySelector('.product-gallery__viewport');
      if (!viewport) return;
      let startX = 0;

      viewport.addEventListener(
        'touchstart',
        (event) => {
          startX = event.touches[0].clientX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        (event) => {
          const delta = event.changedTouches[0].clientX - startX;
          if (Math.abs(delta) < 40) return;
          this.goTo(this.index + (delta < 0 ? 1 : -1));
        },
        { passive: true }
      );
    }

    goTo(next) {
      const total = this.slides.length;
      if (!total) return;
      this.index = ((next % total) + total) % total;

      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === this.index));
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));

      const activeThumb = this.thumbs[this.index];
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }

      this.querySelectorAll('video').forEach((video) => video.pause());
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-reviews-track]');
      if (!this.track) return;

      this.arrows = Array.from(this.querySelectorAll('[data-nav-direction]'));

      this.arrows.forEach((button) => {
        button.addEventListener('click', () => {
          const card = this.track.querySelector('.reviews-carousel__card');
          const step = card ? card.offsetWidth + 20 : 320;
          this.track.scrollBy({
            left: button.dataset.navDirection === 'next' ? step : -step,
            behavior: 'smooth'
          });
        });
      });

      this.updateArrows();
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows(), { passive: true });
    }

    updateArrows() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      this.arrows.forEach((button) => {
        const isNext = button.dataset.navDirection === 'next';
        button.disabled = max <= 1 || (isNext ? x >= max - 1 : x <= 1);
      });
    }
  }

  if (!customElements.get('reviews-carousel')) {
    customElements.define('reviews-carousel', ReviewsCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
